"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ENCRYPTED_DATA_DELIMITER = exports.DEFAULT_RECURSIONS_PER_HASH = exports.DEFAULT_INITIAL_RECURSIONS = exports.DEFAULT_GETUUID_SEEDSIZE = exports.DEFAULT_HASH_ALGORITHM = exports.DEFAULT_SALT_STRATEGY = void 0;
const _1 = require(".");
exports.DEFAULT_SALT_STRATEGY = _1.SaltStrategy.appendPerHash;
// export var DEFAULT_HASH_ALGORITHM: HashAlgorithm = 'SHA-256';
exports.DEFAULT_HASH_ALGORITHM = 'SHA-512';
exports.DEFAULT_GETUUID_SEEDSIZE = 1024;
exports.DEFAULT_INITIAL_RECURSIONS = 20000;
exports.DEFAULT_RECURSIONS_PER_HASH = 1;
exports.DEFAULT_ENCRYPTED_DATA_DELIMITER = ',';
